"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'ai.suggestions.title': 'Ulepszanie Promptu z AI',
    'ai.suggestions.description': 'Wybierz jedną lub więcej sugestii, aby wstawić je do swojego prompt-a do przeglądu. Następnie możesz edytować i wysłać ręcznie.',
    'ai.suggestions.apply': 'Zastosuj Sugestie',
    'ai.suggestions.clarification': 'Dodatkowe wyjaśnienie',
    'ai.suggestions.clarification.label': 'Dodatkowe wyjaśnienie (opcjonalne)',
    'ai.suggestions.clarification.placeholder': 'Dodaj specyficzne wymagania lub kontekst...',
    'ai.suggestions.context.prompt': 'Z wejścia',
    'ai.suggestions.context.message': 'Ostatnia wiadomość',
};
